import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { DialogShellComponent } from '@custom-components/overlay/dialog-shell/dialog-shell.component';

@Component({
  selector: 'confirm-reset-device-dialog',
  imports: [MatIconModule, MatButtonModule, MatDialogModule, TranslateModule, DialogShellComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './confirm-reset-device-dialog.component.html',
})
export class ConfirmResetDeviceDialogComponent {
  readonly dialogRef = inject(MatDialogRef<ConfirmResetDeviceDialogComponent>);

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
